<template>
    <v-card outlined class="pa-2 mb-2 pb-0">
        <table>
            <tr>
                <td rowspan="3">
                    <v-img src="@/assets/sugar_content_v.png" width="128" />
                </td>
                <td>
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    dense 
                                    v-model="top" 
                                    clearable 
                                    label="上" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    dense 
                                    v-model="center" 
                                    clearable 
                                    label="中央" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    dense 
                                    v-model="bottom" 
                                    clearable 
                                    label="下" 
                                    item-text="number" 
                                    outlined
                                    suffix="%"
                                    />
                            </v-col>
                        </v-row>
                    </v-container>
                </td>
            </tr>
        </table>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: Object,
        },
        computed: {
            top: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value.top
                },
                set: function(v) {
                    this.$emit("input", {
                        top: v * 1,
                        center: this.center,
                        bottom: this.bottom
                    })
                }
            },
            center: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value.center
                },
                set: function(v) {
                    this.$emit("input", {
                        top: this.top,
                        center: v * 1,
                        bottom: this.bottom
                    })
                }
            },
            bottom: {
                get: function() {
                    if (this.$props.value == null || this.$props.value == '') {
                        return 0
                    }
                    return this.$props.value.bottom
                },
                set: function(v) {
                    this.$emit("input", {
                        top: this.top,
                        center: this.center,
                        bottom: v * 1
                    })
                }
            },
        },
        // data: function () {
        //     return {
        //         editItems: {
        //             top: 0,
        //             center: 0,
        //             bottom: 0
        //         }
        //     }
        // }
        created: function () {
            console.log("V created")
            if (this.$props.value == null || this.$props.value == '') {
                this.$emit("input", {
                        top: 0,
                        center: 0,
                        bottom: 0
                    })
            }
        }
    }
</script>